import { createMuiTheme } from '@material-ui/core/styles';

const palette = {
  primary: { main: '#795548' },
  secondary: { main: '#dc0f55' }
};
const themeName = 'Dove Gray';
export default createMuiTheme({ palette, themeName });
